import React from 'react'

const highYieldSavingsData = [
  {
    slug: 'wealthfront',
    name: 'Wealthfront',
    ctaUrl: (trackingId) =>
      `https://wealthfront.pxf.io/c/1194261/665384/10429?subId1=${trackingId}`,
    fees: 'No fees',
    minimumBalance: 1,
    slugVertical: 'high_yield_savings',
    fdicInsured: '$1,000,000 FDIC insured via partner banks',
    productName: 'Wealthfront Cash',
  },
  {
    slug: 'discover',
    name: 'Discover',
    ctaUrl: (trackingId) =>
      `https://goto.discover.com/c/1194261/621563/9289?subId1=${trackingId}&adid=Content&adcampaignid=205900201`,
    fees: 'No monthly fees or balance requirements',
    minimumBalance: 0,
    slugVertical: 'high_yield_savings',
    fdicInsured: '$250,000 FDIC insured',
    productName: (
      <span>
        Discover Bank <br /> Online Savings
      </span>
    ),
  },
]
const validDepositAmount = (minimumBalance, depositAmount) => depositAmount >= minimumBalance
const getApy = (slug, slugVertical, lenders, validDeposit) => {
  const individualLender = lenders.find(
    (lender) => lender.rateSlug === slug && lender.vertical === slugVertical,
  )
  if (!lenders.length) {
    return null
  }

  if (!validDeposit) {
    return '0.00'
  }

  return individualLender && [individualLender.minRateVariable, individualLender.vertical]
}
const getEstimatedSavings = (apy, balanceAmt) => {
  if (!apy || !balanceAmt) {
    return null
  }

  return Math.round((apy / 100 / 12 + 1) ** 12 * balanceAmt - balanceAmt)
}
const loadLenders = ({ isScriptLoaded }) => {
  const lenders = []
  const filterVariable = {
    rateType: 'apy',
    term: null,
    variable: true,
  }
  const options = {
    decimals: 2,
    append: '',
    prepend: '',
  }
  const allLenders = [
    { rateSlug: 'wealthfront', vertical: 'high_yield_savings' },
    { rateSlug: 'discover', vertical: 'high_yield_savings' },
  ]

  /* Get the rates after loading the ratesLibrary JS and do it only once. */
  if (isScriptLoaded) {
    // eslint-disable-next-line array-callback-return
    allLenders.map((lender) => {
      const minRateVariable = global.ratesLibrary.getRateValue(
        {
          lenderSlug: lender.rateSlug,
          name: 'rate',
          vertical: lender.vertical,
          ...filterVariable,
        },
        options,
      )

      /* In case there is any problem searching for rates. */

      if (minRateVariable) {
        lenders.push({ minRateVariable, ...lender })
      }
    })
  }

  return lenders
}

const filterAvailableLenders = (hysData, availableLenders) =>
  hysData.filter((lender) =>
    availableLenders.some((availableLender) => availableLender.rateSlug === lender.slug),
  )

export {
  highYieldSavingsData,
  getEstimatedSavings,
  loadLenders,
  getApy,
  validDepositAmount,
  filterAvailableLenders,
}
